import { appointmentUrl, aboutImage, heroLogoImage } from "@/mocks/ppcare";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="order-2 flex flex-col items-center justify-center gap-8 px-6 py-14 text-center md:px-14 lg:order-1 lg:items-start lg:py-24 lg:text-left">
          <img
            src={heroLogoImage}
            alt="Personal Physician Care"
            className="w-full max-w-[300px] object-contain md:max-w-[420px]"
          />
          <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
            A family-owned multi-specialty practice serving South Florida since 1987. Primary
            care, in-house diagnostics and same-day urgent visits — closer to you.
          </p>
          <a
            href={appointmentUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-4 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-calendar-check-line text-lg" />
            Request an Appointment
          </a>
        </div>
        <div className="relative order-1 min-h-[300px] overflow-hidden lg:order-2 lg:min-h-[560px]">
          <img
            src={aboutImage}
            alt="A Personal Physician Care doctor caring for a patient"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/35 via-transparent to-transparent" />
        </div>
      </div>
    </section>
  );
}